<template>
    <div class="row">
        <div class="col-md-12">
            <transition v-if="dataShown" name="view" appear enter-active-class="animated slideInDown" leave-active-class="animated slideOutDown">
                <project-settings-form :settings="projectSettings" @save="saveProject"></project-settings-form>
            </transition>
        </div>
    </div>
</template>

<script>
import ProgressBar from "../../components/Progress";
import NotificationTemplate from "../Notifications/NotificationTemplate";
import axios from "axios";
import {setCookie, url} from "../../plugins/axios";
import ProjectSettingsForm from "../ProjectsSettings/ProjectSettingsForm";
export default {
    components: {ProjectSettingsForm, ProgressBar},
    name: "ProjectsSettings",
    data(){
        return{
            progressValue: 0,
            projects: [],
            current: 0,
            projectSettings: {},
            projectSettingsOld: {},
            dataShown:false,
            docsShown: false,
        }
    },
    methods:{
        notifyVue(type,message) {
            this.$notify({
                component: NotificationTemplate,
                icon: "tim-icons icon-bell-55",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: type,
                message:message,
                timeout: 1500
            });
        },
        prepareData: function(data){
            let temp = JSON.stringify(data);
            temp = temp.split('"is_delete":"0"').join('"is_delete":false');
            temp = temp.split('"is_delete":"1"').join('"is_delete":true');
            temp = temp.split('"is_commercial":"0"').join('"is_commercial":false');
            temp = temp.split('"is_commercial":"1"').join('"is_commercial":true');
            temp = temp.split('"is_show":"0"').join('"is_show":false');
            temp = temp.split('"is_show":"1"').join('"is_show":true');
            temp = temp.split('"is_active":"0"').join('"is_active":false');
            temp = temp.split('"is_active":"1"').join('"is_active":true');
            return JSON.parse(temp);
        },
        getProject(id){
            axios
                .get(url + 'projects/'+id+'/',
                    {
                        withCredentials:'include',
                        crossDomain:true
                    })
                .then((response) => {
                    if (response.data.error === ''){
                        if (response.data.result !== null){
                            this.projectSettings = this.prepareData(response.data.result[0]);
                            this.projectSettingsOld = JSON.parse(JSON.stringify(this.projectSettings));
                            this.current = id;
                            this.dataShown = true;
                        }
                    }
                    else{
                        if (response.data.error === 'Session is over'){
                            setCookie('Authentication','Failed',1);
                            this.$router.push('/login');
                        }
                        else{
                            this.notifyVue('danger',response.data.error);
                        }
                    }
                })
                .catch((error) => {
                    this.notifyVue('danger',error);
                });

        },
        openProject(projectId){
            this.dataShown = false;
            if (projectId > 0){
                this.getProject(projectId);
            }
            else{
                if (projectId < 1){
                    let address = ['','','',''];
                    this.projectSettings = {
                        project_id: 0,
                        full_name: '',
                        short_name: '',
                        site_name: '',
                        description: '',
                        is_delete: false,
                        is_commercial: false,
                        is_show: false,
                        is_active: false,
                        address: address[0] + '||' + address[1] + '||' + address[2] + '||' + address[3]
                    };
                    this.projectSettingsOld = JSON.parse(JSON.stringify(this.projectSettings));
                    this.dataShown = true;
                }
            }
        },
        differencesOfProperties: function(newStr, oldStr) {
            let currentProperties = JSON.parse(newStr);
            let oldProperties = JSON.parse(oldStr);
            let diff = '';
            for (let prop in currentProperties) {
                if (currentProperties[prop] !== oldProperties[prop]){
                    diff = diff + '"' + prop + '":"' + currentProperties[prop] + '",'
                }
            }
            if(diff!==''){diff = diff.substring(0, diff.length-1);}
            return diff;
        },
        saveProject(address){
            this.projectSettings.address = address.join('||');
            if (JSON.stringify(this.projectSettings) === JSON.stringify(this.projectSettingsOld)){
                this.notifyVue('info','Data was updated');
            }
            else{
                let data = '{' + this.differencesOfProperties(JSON.stringify(this.projectSettings),JSON.stringify(this.projectSettingsOld));
                if (this.projectSettings.project_id !== 0){
                    data = JSON.parse(data +  ',"project_id": "' + this.projectSettings.project_id + '"}');
                    axios
                        .put(url + 'update-projects/',
                            {data: data},
                            {
                                withCredentials:'include',
                                crossDomain:true
                            })
                        .then((response) => {
                            if (response.data.error === ''){
                                this.notifyVue('success','Data was updated');
                                this.projectSettingsOld = JSON.parse(JSON.stringify(this.projectSettings));
                                this.getProjectForFilter();
                            }
                            else{
                                if (response.data.error === 'Session is over'){
                                    setCookie('Authentication','Failed',1);
                                    this.$router.push('/login');
                                }
                                else{
                                    this.notifyVue('danger',response.data.error);
                                }
                            }
                        })
                }
                else{
                    data = data + '}';
                    axios
                        .post(url + 'add-projects/',
                            {data: JSON.parse(data)},
                            {
                                withCredentials:'include',
                                crossDomain:true
                            }
                        )
                        .then((response) => {
                            if (response.data.error === ''){
                                this.notifyVue('success','Project was added');
                                this.projectSettingsOld = JSON.parse(JSON.stringify(this.projectSettings));
                            }
                            else{
                                if (response.data.error === 'Session is over'){
                                    setCookie('Authentication','Failed',1);
                                    this.$router.push('/login');
                                }
                                else{
                                    this.notifyVue('danger',response.data.error);
                                }
                            }
                        })
                        .catch((error) => {
                            this.notifyVue('danger',error);
                        })
                }
            }
        },
    },
    created() {
        const params = this.$route.query;
        this.openProject(params.projectId);
    },

}
</script>

<style scoped>

</style>
